import React, { useEffect, useState } from 'react';
import debounce from '../lib/performance/debounce';
import { Breakpoints } from '../types/Breakpoints';

/**
 * Registers a Resize-EventListener on window.
 *
 * This hook shall only be called to provide its value in the AppContext!
 *
 * To get the current breakpoint use:
 * ```
 * const { breakpoint } = useAppContext()
 * ```
 */
export default function useResizeListener(): Breakpoints {
  const [windowInnerWidth, setWindowInnerWidth] = useState<number>(0);

  useEffect(() => {
    if (window) {
      setWindowInnerWidth(window.innerWidth);
    }
  }, []);

  const listener = debounce(() => {
    if (window) {
      setWindowInnerWidth(window.innerWidth);
    }
  }, 350);

  React.useEffect(() => {
    window.addEventListener('resize', listener);

    return () => {
      window.removeEventListener('resize', listener);
    };
  }, [listener]);

  return windowInnerWidth;
}
